import { z } from 'zod'
import { CourseSchema } from './course.schema'

export const TrackSchema = z.object({
  id: z.string(),
  title: z.string().min(1, 'Título é obrigatório'),
  description: z.string().min(10, 'Descrição deve ter pelo menos 10 caracteres'),
  thumbnail: z.string().url().optional(),
    category: z.string().min(1, 'Categoria é obrigatória'),
  courses: z.array(CourseSchema),
  totalDuration: z.number().min(0),
  totalLessons: z.number().min(0),
  progress: z.number().min(0).max(100).optional(),
  enrolledAt: z.date().optional(),
  completedAt: z.date().optional().nullable(),
  rating: z.number().min(1).max(5).optional(),
  totalStudents: z.number().min(0),
  tags: z.array(z.string()),
  status: z.enum(['draft', 'published', 'archived']),
  createdAt: z.date(),
  updatedAt: z.date()
})

export const TrackProgressSchema = z.object({
  trackId: z.string(),
  userId: z.string(),
  progress: z.number().min(0).max(100),
  completedCourses: z.array(z.string()),
  currentCourse: z.string().optional(),
  timeSpent: z.number().min(0),
  lastAccessedAt: z.date()
})

// Form schemas for creating/editing
export const CreateTrackSchema = z.object({
  title: z.string().min(1, 'Título é obrigatório'),
  description: z.string().min(10, 'Descrição deve ter pelo menos 10 caracteres'),
  thumbnail: z.string().url().optional(),
    category: z.string().min(1, 'Categoria é obrigatória'),
  courseIds: z.array(z.string()).min(1, 'Pelo menos um curso é obrigatório'),
  tags: z.array(z.string()).min(1, 'Pelo menos uma tag é obrigatória')
})

export const UpdateTrackSchema = CreateTrackSchema.partial()

// Type exports
export type Track = z.infer<typeof TrackSchema>
export type TrackProgress = z.infer<typeof TrackProgressSchema>
export type CreateTrackData = z.infer<typeof CreateTrackSchema>
export type UpdateTrackData = z.infer<typeof UpdateTrackSchema>